import {
  UN_REVIEW_INVOICE_DATA_REQUEST,
  UN_REVIEW_INVOICE_DATA_SUCCESS,
  UN_REVIEW_INVOICE_DATA_FAILURE,
  REVIEW_INVOICE_DATA_REQUEST,
  REVIEW_INVOICE_DATA_SUCCESS,
  REVIEW_INVOICE_DATA_FAILURE,
  WS_CONNECT_REQUEST,
  WS_CONNECT_SUCCESS,
  WS_CONNECT_FAILURE,
  WS_DISCONNECT,
  WS_MESSAGE_RECEIVED,
  WS_STATUS_SET_LOADING,
  PAYMENT_STATUS_DATA_REQUEST,
  PAYMENT_STATUS_DATA_SUCCESS,
  PAYMENT_STATUS_DATA_FAILURE,
} from "../po-invoice/poInvoiceTypes";

const initialStateForUnReviewInvoice = {
  loading: false,
  data: {}, 
  error: "",
};

const unReviewInvoiceReducer = (state = initialStateForUnReviewInvoice, action) => {
  switch (action.type) {
    case UN_REVIEW_INVOICE_DATA_REQUEST:
      return { ...state, loading: true };
    case UN_REVIEW_INVOICE_DATA_SUCCESS:
      return { loading: false, data: action.payload, error: "" };
    case UN_REVIEW_INVOICE_DATA_FAILURE:
      return { loading: false, data: {}, error: action.payload };
    default:
      return state;
  }
};



const initialStateForReviewInvoice = {
  loading: false,
  data: {}, 
  error: "",
};

const reviewInvoiceReducer = (state = initialStateForReviewInvoice, action) => {
  switch (action.type) {
    case REVIEW_INVOICE_DATA_REQUEST:
      return { ...state, loading: true };
    case REVIEW_INVOICE_DATA_SUCCESS:
      return { loading: false, data: action.payload, error: "" };
    case REVIEW_INVOICE_DATA_FAILURE:
      return { loading: false, data: {}, error: action.payload };
    default:
      return state;
  }
};



const initialWsState = {
  connected: false,
  loading: false,
  error: null,
  socketId: null,
  lastEventTs: null,
  data: null,
};

const websocketReducer = (state = initialWsState, action) => {
  switch (action.type) {
    case WS_CONNECT_REQUEST:
      return { ...state, loading: true, error: null };
    case WS_CONNECT_SUCCESS:
      return {
        ...state,
        loading: false,
        connected: true,
        socketId: action.payload?.socketId || null,
      };
    case WS_CONNECT_FAILURE:
      return {
        ...state,
        loading: false,
        connected: false,
        error: action.payload,
      };
    case WS_DISCONNECT:
      return { ...state, connected: false, socketId: null };
    case WS_STATUS_SET_LOADING:
      return { ...state, loading: action.payload };
    case WS_MESSAGE_RECEIVED:
      return {
        ...state,
        data: action.payload,
        lastEventTs: Date.now(),
      };
    default:
      return state;
  }
};

// const initialStateForPaymentStatus = {
//   loading: false,
//   paymentStatus: [],
//   error: "",
// };

// const paymentStatusReducer = (state = initialStateForPaymentStatus, action) => {
//   switch (action.type) {
//     case PAYMENT_STATUS_DATA_REQUEST:
//       return { ...state, loading: true };

//     case PAYMENT_STATUS_DATA_SUCCESS: {
//       const arr = Array.isArray(action.payload)
//         ? action.payload
//         : Array.isArray(action.payload?.data)
//         ? action.payload.data
//         : [];
//       return { loading: false, paymentStatus: arr, error: "" };
//     }

//     case PAYMENT_STATUS_DATA_FAILURE:
//       return { loading: false, paymentStatus: [], error: action.payload };

//     default:
//       return state;
//   }
// };


const initialStateForPaymentStatus = {
  loading: false,
  data: {}, 
  error: "",
};

const paymentStatusReducer = (state = initialStateForPaymentStatus, action) => {
  switch (action.type) {
    case PAYMENT_STATUS_DATA_REQUEST:
      return { ...state, loading: true };
    case PAYMENT_STATUS_DATA_SUCCESS:
      return { loading: false, data: action.payload, error: "" };
    case PAYMENT_STATUS_DATA_FAILURE:
      return { loading: false, data: {}, error: action.payload };
    default:
      return state;
  }
};


export {
  unReviewInvoiceReducer,
  reviewInvoiceReducer,
  websocketReducer,
  paymentStatusReducer,
};
